/**
 * Site Activation workflow statuses — helpers over existing enums.
 * Enums live in `./siteActivation/siteActivation.type.ts` (wire format SSOT).
 */

import {
  ActivationStatus,
  ChecklistItemStatus,
  DocumentStatus,
  SiteWorkflowStatus,
} from "./siteActivation/siteActivation.type";
import { createStatusHelpers } from "./statusHelpers";

export {
  ActivationStatus,
  ChecklistItemStatus,
  DocumentStatus,
  SiteWorkflowStatus,
};

export const SITE_WORKFLOW_STATUS = SiteWorkflowStatus;
export const ACTIVATION_STATUS = ActivationStatus;
export const ACTIVATION_DOCUMENT_STATUS = DocumentStatus;
export const CHECKLIST_ITEM_STATUS = ChecklistItemStatus;

const workflowHelpers = createStatusHelpers(
  SiteWorkflowStatus as unknown as Record<string, SiteWorkflowStatus>,
  SiteWorkflowStatus.SELECTED,
);

export const isSiteWorkflowStatus = workflowHelpers.isStatus;
export const isAnySiteWorkflowStatus = workflowHelpers.isAnyStatus;
export const normalizeSiteWorkflowStatus = workflowHelpers.normalize;
export const tryNormalizeSiteWorkflowStatus = workflowHelpers.tryNormalize;

const activationHelpers = createStatusHelpers(
  ActivationStatus as unknown as Record<string, ActivationStatus>,
  ActivationStatus.DRAFT,
  {
    CHECKLIST_SUBMITTED: ActivationStatus.SUBMITTED_FOR_REVIEW,
    DOCUMENTS_UNDER_REVIEW: ActivationStatus.SUBMITTED_FOR_REVIEW,
    // Keep PENDING_APPROVAL as itself — do not remap to APPROVED (would break gates/labels).
  },
);

export const isActivationStatus = activationHelpers.isStatus;
export const isAnyActivationStatus = activationHelpers.isAnyStatus;
export const normalizeActivationStatus = activationHelpers.normalize;
export const tryNormalizeActivationStatus = activationHelpers.tryNormalize;

const docHelpers = createStatusHelpers(
  DocumentStatus as unknown as Record<string, DocumentStatus>,
  DocumentStatus.PENDING,
);

export const isActivationDocumentStatus = docHelpers.isStatus;
export const isAnyActivationDocumentStatus = docHelpers.isAnyStatus;
export const normalizeActivationDocumentStatus = docHelpers.normalize;

const itemHelpers = createStatusHelpers(
  ChecklistItemStatus as unknown as Record<string, ChecklistItemStatus>,
  ChecklistItemStatus.NOT_STARTED,
);

export const isChecklistItemStatus = itemHelpers.isStatus;
export const isAnyChecklistItemStatus = itemHelpers.isAnyStatus;
export const normalizeChecklistItemStatus = itemHelpers.normalize;
